import { apiRequest } from "./api";
import type { CancelledGigHistoryItemResponse } from "../types/cancelledGigTypes";
import type {
  AdultDashboardCompletedGigItemResponse,
  AdultDashboardSnapshotResponse,
} from "../types/adultDashboardTypes";
import type { ResolvedGigIssueItemResponse } from "../types/resolvedIssueTypes";

export const adultDashboardApi = {
  getSnapshot(): Promise<AdultDashboardSnapshotResponse> {
    return apiRequest<AdultDashboardSnapshotResponse>("/api/adult/dashboard/snapshot", {
      method: "GET",
    });
  },

  listCompletedGigs(): Promise<AdultDashboardCompletedGigItemResponse[]> {
    return apiRequest<AdultDashboardCompletedGigItemResponse[]>("/api/adult/completed-gigs", {
      method: "GET",
    });
  },

  listResolvedIssues(): Promise<ResolvedGigIssueItemResponse[]> {
    return apiRequest<ResolvedGigIssueItemResponse[]>("/api/adult/resolved-issues", {
      method: "GET",
    });
  },

  listCancelledGigs(): Promise<CancelledGigHistoryItemResponse[]> {
    return apiRequest<CancelledGigHistoryItemResponse[]>("/api/adult/cancelled-gigs", {
      method: "GET",
    });
  },
};
